import { showUnauthorisedAccount } from '../helpers/restrictions/show-not-authorised/show-not-authorised.js'

let interceptFetchResponseIsLoaded = false

/**
 * Inspired by https://blog.logrocket.com/intercepting-javascript-fetch-api-requests-responses/
 */
export function interceptFetchResponse (browserAppUser) {
  if (interceptFetchResponseIsLoaded) return
  interceptFetchResponseIsLoaded = true

  const { fetch: originalFetch } = window

  window.fetch = async (...args) => {
    const [resource, config] = args
    // request interceptor here
    const response = await originalFetch(resource, config)
    // response interceptor here
    // console.log('interceptor', response.ok, response.status, response)

    if (!response.ok && response.status === 401) {
      console.warn('401: Not Authenticated')
      browserAppUser.logout()
      showUnauthorisedAccount({ isLoggedIn: browserAppUser.isLoggedIn() })
      console.warn('logout done')
    }

    if (!response.ok && response.status === 403) {
      console.warn('403: Not Authorised')
      showUnauthorisedAccount({ isLoggedIn: browserAppUser.isLoggedIn() })
    }

    return response
  }
}
